/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */
import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages as applicantTrackerMessages } from '../i18n/applicant-tracker-messages.ts';
import { messages } from '../i18n/messages.ts';

import { tagBackgroundColors, tagBorderColors, templateStyles } from './styles.ts';

const ApplicantTracker: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <g clipPath="url(#applicantTracker-a)">
        <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        <g clipPath="url(#applicantTracker-b)">
          <rect
            width={60.19}
            height={216}
            x={4}
            y={4}
            fill={templateStyles['boardBackground']}
            rx={0.93}
          />
          <rect
            width={18.7}
            height={5.92}
            x={6.64}
            y={9.13}
            fill={tagBackgroundColors['redLight']}
            rx={0.78}
          />
          <rect
            width={18.7}
            height={5.92}
            x={6.64}
            y={9.13}
            stroke={tagBorderColors['redLight']}
            strokeWidth={0.3}
            rx={0.78}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={8} y={13.25}>
              {formatMessage(
                applicantTrackerMessages['applicant-tracker.field-2-select-option-1']
              )}
            </tspan>
          </text>
          <g filter="url(#applicantTracker-c)">
            <rect
              width={55.21}
              height={70.87}
              x={6.49}
              y={18.93}
              fill={templateStyles['background']}
              rx={1.24}
            />
            <rect
              width={31.71}
              height={8.24}
              x={8.98}
              y={22.67}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M12.71 24.77a2.02 2.02 0 1 0 1.01 3.77l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.09.56-.25.8a.96.96 0 0 1-.79.4.69.69 0 0 1-.66-.43c-.36.41-.94.6-1.41.32-.55-.32-.65-1.06-.32-1.63.32-.56 1.01-.85 1.56-.53a1.07 1.07 0 0 1 .51 1c0 .22.01.44.07.6.03.09.06.14.1.16.03.03.07.05.15.05a.5.5 0 0 0 .4-.22.9.9 0 0 0 .17-.51c0-1.12-.9-2.02-2.02-2.02Zm.66 1.9c.01-.25-.1-.46-.27-.55-.27-.16-.7-.05-.93.36-.23.4-.12.83.15.98.27.16.7.04.93-.36a.92.92 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="M18.12 28.36a1.3 1.3 0 0 1-1.24-.75 2 2 0 0 1-.16-.85c0-.34.05-.62.17-.86.11-.24.27-.43.48-.56.22-.13.47-.2.75-.2.3 0 .55.07.76.2.2.13.37.32.48.56.12.24.17.52.17.85 0 .33-.05.62-.17.86a1.28 1.28 0 0 1-1.24.75Zm0-.35c.21 0 .4-.05.55-.16a1 1 0 0 0 .35-.43c.08-.2.12-.41.12-.66 0-.26-.04-.49-.12-.67a.98.98 0 0 0-.35-.44.95.95 0 0 0-.55-.15c-.2 0-.38.05-.54.15a1 1 0 0 0-.35.44c-.08.18-.12.4-.12.66s.04.48.12.67c.08.18.2.33.35.43.15.1.33.16.54.16Zm2.05.28v-3.2h.37v3.2h-.37Zm1.09 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.07.1.07.18a.25.25 0 0 1-.26.26Zm1.53 2.74-.85-2.3h.39l.63 1.9h.03l.63-1.9h.39l-.85 2.3h-.37Zm1.72 0v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08a.25.25 0 0 1 0 .36.25.25 0 0 1-.18.07Zm1.51 2.78a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.18.28-.23.13-.06.28-.1.45-.1l.85-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.28-.08.44-.08.19 0 .34.03.47.09.13.06.23.15.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.78.78 0 0 1-.41.34.91.91 0 0 1-.29.04Zm3.9-.04v-1.32l-1.1-1.75h.44l.83 1.36h.03l.83-1.36h.43l-1.08 1.75v1.32h-.39Zm2.25.04a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.18.28-.23.13-.06.28-.1.46-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.28-.08.44-.08.19 0 .35.03.48.09s.22.15.3.26c.06.11.1.25.1.4v1.58h-.38v-.34h-.03a.78.78 0 0 1-.41.34.91.91 0 0 1-.28.04Zm1.77-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .46.07.6.22.13.14.2.35.2.62v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.23.77.77 0 0 0-.08.34v1.36h-.37Zm3.49.8c-.19 0-.35-.02-.49-.07a.79.79 0 0 1-.33-.22.65.65 0 0 1-.15-.33h.4c.01.09.07.16.17.21.1.06.23.09.4.09.2 0 .36-.05.48-.14.11-.1.17-.22.17-.4v-.46h-.03a.78.78 0 0 1-.43.36.94.94 0 0 1-.3.04.92.92 0 0 1-.5-.14.94.94 0 0 1-.34-.4 1.33 1.33 0 0 1-.11-.56c0-.22.04-.41.11-.58a.91.91 0 0 1 .85-.54c.12 0 .21.02.3.06.1.03.18.08.25.14a.8.8 0 0 1 .17.22h.03V26h.37v2.26a.8.8 0 0 1-.48.74c-.15.06-.33.1-.54.1Zm-.02-1.25c.14 0 .26-.03.36-.1.1-.06.18-.15.24-.27a.93.93 0 0 0 .08-.4.94.94 0 0 0-.08-.41.64.64 0 0 0-.24-.28.64.64 0 0 0-.36-.1.63.63 0 0 0-.36.1.64.64 0 0 0-.23.28 1 1 0 0 0-.07.4 1 1 0 0 0 .07.41c.06.12.13.2.23.27s.22.1.36.1Z"
            />
            <rect
              width={39.7}
              height={5.92}
              x={9.13}
              y={33.55}
              fill={tagBackgroundColors['yellow']}
              rx={0.78}
            />
            <rect
              width={39.7}
              height={5.92}
              x={9.13}
              y={33.55}
              stroke={tagBorderColors['yellow']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={10.8} y={37.67}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-4']
                )}
              </tspan>
            </text>
            <rect
              width={30.49}
              height={8.24}
              x={8.98}
              y={42.11}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M10.61 47.73v-3.07H11l1.75 2.53-.25-.14h.2v-2.39h.37v3.07h-.37l-1.76-2.51.26.13h-.2v2.38h-.38Zm4.13.04c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.37-.4 1.45 1.45 0 0 1-.13-.64c0-.25.05-.46.13-.64.09-.18.21-.31.37-.4.16-.1.34-.15.56-.15.22 0 .4.05.57.14.15.1.27.23.36.41.09.18.13.39.13.63 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.32c.15 0 .27-.04.37-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46 0-.19-.03-.34-.08-.47a.62.62 0 0 0-.23-.29.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.27-.08.45 0 .19.03.34.08.47.06.13.13.23.23.3.1.06.23.1.37.1Zm2.2.28-.85-2.29h.39l.63 1.89h.03l.63-1.89h.39l-.85 2.3h-.37Zm3.68 0V45.1h-.03l-.78.57v-.4l.81-.6H21v3.07h-.38Zm2.32.05c-.22 0-.4-.03-.58-.1a.97.97 0 0 1-.4-.32.77.77 0 0 1-.13-.46.76.76 0 0 1 .31-.63c.1-.07.21-.13.34-.16a.82.82 0 0 1-.4-.26.65.65 0 0 1-.14-.43c0-.16.04-.3.13-.41.08-.13.2-.22.35-.29.15-.07.33-.1.52-.1.2 0 .37.03.52.1.15.07.27.16.35.29.1.12.13.26.13.41 0 .17-.05.3-.14.43a.8.8 0 0 1-.4.26.86.86 0 0 1 .57.44c.06.1.08.22.08.35 0 .18-.04.33-.14.46a.95.95 0 0 1-.4.31 1.4 1.4 0 0 1-.57.11Zm0-.33a.9.9 0 0 0 .37-.07c.11-.05.2-.12.26-.2a.5.5 0 0 0 .1-.3.5.5 0 0 0-.1-.3.62.62 0 0 0-.25-.2.9.9 0 0 0-.38-.08.9.9 0 0 0-.38.07c-.1.05-.2.12-.25.2a.5.5 0 0 0-.1.3v.01c0 .11.04.21.1.3.06.08.15.15.26.2.1.05.23.07.37.07Zm0-1.49c.12 0 .23-.02.33-.06.09-.04.16-.1.21-.18a.46.46 0 0 0 .08-.26c0-.1-.02-.2-.08-.27a.52.52 0 0 0-.21-.18.76.76 0 0 0-.33-.07.76.76 0 0 0-.33.07c-.09.04-.16.1-.21.18a.46.46 0 0 0-.08.26c0 .1.02.2.08.27.05.08.12.14.21.18.1.04.2.06.33.06Zm1.5 2.55.18-1.2h.42l-.33 1.2h-.28Zm2.6-.78v-.26l1.04-1.12.3-.35c.08-.1.13-.18.16-.26a.66.66 0 0 0 .05-.24c0-.12-.03-.21-.07-.3a.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.33.07.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.36a.92.92 0 0 1 .48-.82c.15-.08.33-.12.52-.12.18 0 .34.04.48.11.15.08.26.18.34.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.11.23-.22.36-.1.13-.24.3-.43.48l-.8.82.1-.17v.17l-.09-.06h1.55v.34h-1.99Zm3.66.08a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.53 2.53 0 0 1-.13-.86c0-.33.04-.62.13-.86.08-.24.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.16.13.29.31.37.55.1.24.14.53.14.86 0 .33-.05.61-.14.85-.08.24-.2.43-.37.56a.9.9 0 0 1-.58.2Zm0-.34c.15 0 .27-.05.37-.15a1 1 0 0 0 .25-.44c.05-.2.08-.42.08-.68 0-.27-.03-.49-.08-.68a.98.98 0 0 0-.25-.44.51.51 0 0 0-.37-.15.52.52 0 0 0-.38.15 1 1 0 0 0-.24.44c-.05.19-.08.41-.08.68 0 .26.03.49.08.68a1 1 0 0 0 .24.44c.1.1.23.15.38.15Zm1.71.26v-.26l1.04-1.12c.13-.15.24-.26.3-.35.08-.1.13-.18.16-.26a.67.67 0 0 0 .05-.24c0-.12-.02-.21-.07-.3a.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.32.07.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.92.92 0 0 1 .48-.82c.15-.08.33-.12.52-.12.18 0 .34.04.49.11.14.08.25.18.33.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.44.48l-.79.82.1-.17v.17l-.1-.06h1.55v.34h-1.99Zm3.97 0v-.63h-1.5v-.35a82.71 82.71 0 0 1 1.32-2.09h.56v2.1h.43v.34h-.43v.63h-.38Zm-1.1-.97h1.1v-1.74h-.02a21.38 21.38 0 0 0-.66 1.01 45.16 45.16 0 0 0-.42.7v.03Z"
            />
            <rect
              width={49.71}
              height={8.24}
              x={8.98}
              y={52.84}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M12.71 54.94a2.02 2.02 0 1 0 1.01 3.78l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.09.56-.25.79a.96.96 0 0 1-.79.42.69.69 0 0 1-.66-.44c-.36.41-.94.59-1.41.31-.55-.31-.65-1.06-.32-1.62.32-.56 1.01-.85 1.56-.53a1.06 1.06 0 0 1 .51 1c0 .22.01.44.07.6.03.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c.01-.25-.1-.45-.27-.55-.27-.15-.7-.04-.93.37-.23.4-.12.83.15.98.27.15.7.04.93-.36a.92.92 0 0 0 .12-.4v-.04Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={16.44} y={58.13}>
                Christine Sanchez
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={8.98} y={68.24}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-1-cell-6']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={8.98} y={77.73}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-1-cell-7']
                ).substring(0, 18)}
              </tspan>
              <tspan x={8.98} y={83.95}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-1-cell-7']
                ).substring(18)}
              </tspan>
            </text>
          </g>
          <path
            fill={templateStyles['icon']}
            fillRule="evenodd"
            d="M22.6 99.07V101h.48v-1.94h1.94v-.47h-1.94v-1.94h-.47v1.94h-1.95v.47h1.95Z"
            clipRule="evenodd"
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            fontWeight={510}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={26.84} y={99.99}>
              {formatMessage(messages['templates-preview.add-entry'])}
            </tspan>
          </text>
        </g>
        <g clipPath="url(#applicantTracker-d)">
          <rect
            width={60.19}
            height={216}
            x={67.2}
            y={4}
            fill={templateStyles['boardBackground']}
            rx={0.93}
          />
          <rect
            width={29.7}
            height={5.92}
            x={69.84}
            y={9.13}
            fill={tagBackgroundColors['greyLight']}
            rx={0.78}
          />
          <rect
            width={29.7}
            height={5.92}
            x={69.84}
            y={9.13}
            stroke={tagBorderColors['greyLight']}
            strokeWidth={0.3}
            rx={0.78}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={71.3} y={13.25}>
              {formatMessage(
                applicantTrackerMessages['applicant-tracker.field-2-select-option-2']
              )}
            </tspan>
          </text>
          <g filter="url(#applicantTracker-e)">
            <rect
              width={55.21}
              height={76.87}
              x={69.69}
              y={18.93}
              fill={templateStyles['background']}
              rx={1.24}
            />
            <rect
              width={32.71}
              height={8.24}
              x={72.18}
              y={22.67}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M75.91 24.77a2.02 2.02 0 1 0 1.01 3.77l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.8a.96.96 0 0 1-.79.4.69.69 0 0 1-.66-.43c-.36.41-.93.6-1.4.32-.56-.32-.65-1.06-.33-1.63.32-.56 1.01-.85 1.57-.53a1.07 1.07 0 0 1 .5 1c0 .22.01.44.07.6.03.09.06.14.1.16.03.03.07.05.15.05a.5.5 0 0 0 .41-.22.9.9 0 0 0 .17-.51c0-1.12-.91-2.02-2.03-2.02Zm.67 1.9c0-.25-.1-.46-.28-.55-.27-.16-.7-.05-.93.36-.23.4-.11.83.15.98.27.16.7.04.93-.36a.92.92 0 0 0 .13-.4v-.03Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="m79.8 28.29 1.12-3.07h.3v.5h-.12l-.9 2.57h-.4Zm.5-.88.13-.32h1.38l.12.32h-1.62Zm1.73.88-.9-2.57v-.5h.17l1.13 3.07h-.4Zm.9 0v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .45.07.6.22.13.14.2.35.2.62v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.23.77.77 0 0 0-.07.34v1.36h-.37Zm2.54 0v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .46.07.6.22.13.14.2.35.2.62v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.2.23.77.77 0 0 0-.08.34v1.36h-.37Zm2.55 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.07.1.07.18a.25.25 0 0 1-.26.26Zm1.82 2.78c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.05-.45.13-.62a.97.97 0 0 1 .9-.57c.21 0 .39.04.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.83v-.3h1.64l-.18.27v-.14c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.62.62 0 0 0-.23.26 1 1 0 0 0-.09.44v.14c0 .17.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.01.26-.04a.6.6 0 0 0 .2-.11.4.4 0 0 0 .1-.14v-.01h.38v.01a.7.7 0 0 1-.11.23.85.85 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm4.05.03a1.3 1.3 0 0 1-.72-.2c-.2-.13-.36-.31-.47-.55-.1-.24-.16-.52-.16-.85 0-.34.05-.62.16-.86s.27-.43.47-.56c.2-.13.45-.2.72-.2.22 0 .41.05.59.14.18.08.32.2.44.35.11.14.19.32.21.51h-.38a.84.84 0 0 0-.86-.64c-.2 0-.36.05-.5.15a.98.98 0 0 0-.34.44c-.08.18-.12.4-.12.66s.04.48.12.67a.87.87 0 0 0 .84.59c.15 0 .28-.02.4-.07a.8.8 0 0 0 .29-.2.72.72 0 0 0 .16-.3h.4a1.06 1.06 0 0 1-.66.8c-.17.08-.37.12-.59.12Zm1.86-.07v-3.2h.37v3.2h-.37Zm1.71.04a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.15-.18.28-.23.12-.06.27-.1.45-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.05.2.14.27.08.07.2.1.33.1.12 0 .24-.03.33-.08a.6.6 0 0 0 .23-.2.52.52 0 0 0 .09-.3v-.71c0-.14-.04-.25-.13-.32-.09-.08-.21-.12-.39-.12a.68.68 0 0 0-.33.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.27-.08.44-.08.18 0 .34.03.47.09.13.06.23.15.3.26.06.11.1.25.1.4v1.58h-.37v-.34h-.04a.78.78 0 0 1-.4.34.91.91 0 0 1-.29.04Zm1.78-.04v-2.3h.37v.35h.03a.54.54 0 0 1 .22-.28c.1-.07.24-.1.4-.1h.1l.08.01v.36a1.05 1.05 0 0 0-.23-.02.67.67 0 0 0-.31.07.54.54 0 0 0-.22.2.55.55 0 0 0-.07.29v1.42h-.37Zm2.53.04c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.05-.45.13-.62a1 1 0 0 1 .36-.42c.16-.1.34-.15.54-.15.21 0 .39.04.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.83v-.3h1.65l-.19.27v-.14c0-.18-.03-.33-.08-.45a.56.56 0 0 0-.22-.26.61.61 0 0 0-.33-.08.61.61 0 0 0-.33.09.61.61 0 0 0-.23.26.99.99 0 0 0-.09.44v.14c0 .17.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.01.27-.04a.6.6 0 0 0 .18-.11.4.4 0 0 0 .1-.14l.02-.01h.37v.01a.69.69 0 0 1-.11.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Z"
            />
            <rect
              width={34.7}
              height={5.92}
              x={72.33}
              y={33.55}
              fill={tagBackgroundColors['magenta']}
              rx={0.78}
            />
            <rect
              width={34.7}
              height={5.92}
              x={72.33}
              y={33.55}
              stroke={tagBorderColors['magenta']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={73} y={37.67}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-6']
                )}
              </tspan>
            </text>
            <rect
              width={29.49}
              height={8.24}
              x={72.18}
              y={42.11}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M74.47 47.8c-.13 0-.25-.01-.35-.05a.75.75 0 0 1-.44-.4.93.93 0 0 1-.07-.31V47h.38v.02c.01.07.03.14.07.21.04.06.09.12.16.16.07.03.15.05.25.05.17 0 .3-.05.39-.14.09-.1.13-.25.13-.43v-2.22h.39v2.22c0 .2-.04.36-.11.5a.74.74 0 0 1-.31.32 1 1 0 0 1-.49.1Zm2.27-.03a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.15-.17.28-.23.12-.05.28-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.11.27c0 .12.04.21.13.28.08.06.2.1.33.1.12 0 .24-.03.33-.08.1-.05.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.72c0-.14-.04-.25-.13-.32s-.21-.11-.39-.11a.68.68 0 0 0-.33.07.36.36 0 0 0-.18.2v.02h-.37V46a.61.61 0 0 1 .15-.31.8.8 0 0 1 .31-.21c.13-.05.27-.08.44-.08.18 0 .34.03.47.1.13.05.23.14.3.26.07.1.1.25.1.4v1.57h-.37v-.33h-.03a.78.78 0 0 1-.41.33.91.91 0 0 1-.29.04Zm1.78-.04v-2.29h.37v.35h.03a.65.65 0 0 1 .25-.29c.11-.07.25-.1.42-.1.26 0 .45.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.35h-.37Zm4.51 0V45.1H83l-.78.57v-.4l.82-.6h.38v3.07h-.39Zm2.28.08c-.19 0-.36-.04-.5-.12a.92.92 0 0 1-.52-.75v-.02h.36v.02a.58.58 0 0 0 .34.46c.1.04.2.07.33.07a.64.64 0 0 0 .6-.34c.05-.1.08-.23.08-.37a.72.72 0 0 0-.09-.36.63.63 0 0 0-.24-.25.69.69 0 0 0-.35-.1c-.1 0-.2.02-.28.05a.66.66 0 0 0-.37.33h-.33l.16-1.77h1.7v.35h-1.4l-.1 1.03h.03c.05-.06.1-.12.17-.17a.9.9 0 0 1 .49-.14.94.94 0 0 1 .86.5c.09.15.13.32.13.52 0 .21-.05.4-.14.55a.97.97 0 0 1-.38.37c-.16.1-.34.14-.55.14Zm1.44.7.19-1.2h.42l-.33 1.2h-.28Zm2.61-.78v-.26l1.04-1.12.3-.35c.08-.1.13-.18.16-.26a.66.66 0 0 0 .05-.24c0-.12-.03-.21-.07-.3a.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.32.07.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.92.92 0 0 1 .48-.82c.15-.08.33-.12.52-.12.18 0 .34.04.49.11.14.08.25.18.33.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.44.48l-.79.82.1-.17v.17l-.1-.06h1.55v.34h-1.99Zm3.66.08a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.53 2.53 0 0 1-.13-.86c0-.33.04-.62.13-.86.08-.24.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.16.13.29.31.38.55.08.24.13.53.13.86 0 .33-.05.61-.13.85-.1.24-.22.43-.38.56a.9.9 0 0 1-.58.2Zm0-.34c.15 0 .27-.05.38-.15a1 1 0 0 0 .24-.44c.05-.2.08-.42.08-.68 0-.27-.03-.49-.08-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.38.15 1 1 0 0 0-.23.44c-.06.19-.09.41-.09.68 0 .26.03.49.09.68a1 1 0 0 0 .23.44c.1.1.23.15.38.15Zm1.72.26v-.26l1.03-1.12.31-.35c.07-.1.13-.18.16-.26a.66.66 0 0 0 .04-.24.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.32.07.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.92.92 0 0 1 .48-.82c.16-.08.33-.12.53-.12.17 0 .33.04.48.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17v.17l-.1-.06h1.55v.34h-1.98Zm3.63.08c-.19 0-.36-.04-.5-.12a.92.92 0 0 1-.52-.75v-.02h.36v.02a.58.58 0 0 0 .34.46c.1.04.2.07.33.07a.64.64 0 0 0 .6-.34c.06-.1.09-.23.09-.37a.72.72 0 0 0-.1-.36.63.63 0 0 0-.23-.25.69.69 0 0 0-.36-.1c-.1 0-.2.02-.28.05a.66.66 0 0 0-.37.33h-.33l.16-1.77h1.71v.35h-1.4l-.1 1.03h.02c.05-.06.1-.12.17-.17a.9.9 0 0 1 .49-.14.94.94 0 0 1 .86.5c.09.15.13.32.13.52 0 .21-.05.4-.14.55a.97.97 0 0 1-.37.37c-.16.1-.35.14-.56.14Z"
            />
            <rect
              width={49.71}
              height={8.24}
              x={72.18}
              y={52.84}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M75.91 54.94a2.02 2.02 0 1 0 1.01 3.78l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.79a.96.96 0 0 1-.79.42.69.69 0 0 1-.66-.44c-.36.41-.93.59-1.4.31-.56-.31-.65-1.06-.33-1.62s1.01-.85 1.57-.53a1.06 1.06 0 0 1 .5 1c0 .22.01.44.07.6.03.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .41-.23.9.9 0 0 0 .17-.5c0-1.12-.91-2.03-2.03-2.03Zm.67 1.9c0-.25-.1-.45-.28-.55-.27-.15-.7-.04-.93.37-.23.4-.11.83.15.98.27.15.7.04.93-.36a.92.92 0 0 0 .13-.4v-.04Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={79.65} y={58.13}>
                Christine Sanchez
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={72.18} y={68.24}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-2-cell-6']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={72.18} y={77.73}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-2-cell-7']
                ).substring(0, 16)}
              </tspan>
              <tspan x={72.18} y={83.95}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-2-cell-7']
                ).substring(16, 37)}
              </tspan>
              <tspan x={72.18} y={90.17}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-2-cell-7']
                ).substring(37)}
              </tspan>
            </text>
          </g>
          <g filter="url(#applicantTracker-f)">
            <rect
              width={55.21}
              height={127.36}
              x={69.69}
              y={98.29}
              fill={templateStyles['background']}
              rx={1.51}
            />
            <rect
              width={40.71}
              height={8.24}
              x={72.18}
              y={102.02}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M75.91 104.12a2.02 2.02 0 1 0 1.01 3.78l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.79a.96.96 0 0 1-.79.41.69.69 0 0 1-.66-.44c-.36.42-.93.6-1.4.32-.56-.32-.65-1.06-.33-1.62s1.01-.85 1.57-.53a1.06 1.06 0 0 1 .5 1c0 .22.01.44.07.6.03.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .41-.23.9.9 0 0 0 .17-.5c0-1.12-.91-2.03-2.03-2.03Zm.67 1.9c0-.25-.1-.45-.28-.55-.27-.15-.7-.04-.93.36-.23.4-.11.83.15.99.27.15.7.04.93-.36a.92.92 0 0 0 .13-.4v-.04Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="m79.8 107.64 1.12-3.06h.3v.5h-.12l-.9 2.56h-.4Zm.5-.87.13-.33h1.38l.12.33h-1.62Zm1.73.88-.9-2.58v-.5h.17l1.13 3.08h-.4Zm1.56.03a.9.9 0 0 1-.44-.1.64.64 0 0 1-.26-.28 1.11 1.11 0 0 1-.1-.46v-1.49h.38v1.4c0 .2.04.36.12.46.08.1.21.15.4.15.1 0 .18-.02.26-.05a.53.53 0 0 0 .2-.13c.05-.05.09-.12.11-.2a.86.86 0 0 0 .04-.27v-1.36h.37v2.3h-.37v-.35h-.03a.64.64 0 0 1-.15.21.65.65 0 0 1-.23.13.93.93 0 0 1-.3.05Zm2.56 0c-.17 0-.32-.02-.45-.07a.78.78 0 0 1-.32-.22.6.6 0 0 1-.13-.33h.37c.04.1.1.17.19.23s.2.09.35.09c.1 0 .2-.02.28-.05a.46.46 0 0 0 .18-.12.28.28 0 0 0 .07-.19.25.25 0 0 0-.1-.2.72.72 0 0 0-.3-.13l-.35-.09a1.3 1.3 0 0 1-.36-.13.54.54 0 0 1-.2-.2.58.58 0 0 1-.07-.29c0-.13.04-.24.11-.34.08-.1.18-.18.3-.24.14-.06.28-.09.45-.09.16 0 .3.03.42.08.13.05.23.12.3.21.08.1.12.2.14.33h-.36a.37.37 0 0 0-.17-.23.6.6 0 0 0-.34-.08c-.09 0-.17.02-.24.05a.4.4 0 0 0-.17.11.27.27 0 0 0-.06.18c0 .06.01.1.04.14.03.04.07.08.13.1.05.04.13.06.22.09l.35.08c.21.05.37.13.48.23.1.1.16.23.16.39 0 .14-.04.26-.12.37a.8.8 0 0 1-.33.24c-.14.06-.3.09-.47.09Zm2.29-.02c-.24 0-.41-.05-.52-.14-.1-.1-.15-.25-.15-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.02.24.08.3.05.06.13.08.25.08a1.83 1.83 0 0 0 .17 0v.31a1.94 1.94 0 0 1-.21.02Zm.77-.02v-2.29h.37v2.3h-.37Zm.19-2.73a.25.25 0 0 1-.18-.08.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.07c.07 0 .13.02.18.07a.25.25 0 0 1 0 .36.25.25 0 0 1-.18.08Zm.88 2.73v-2.29h.37v.35h.03a.65.65 0 0 1 .26-.29c.1-.06.24-.1.41-.1.26 0 .46.08.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.08-.1-.22-.15-.4-.15a.6.6 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Zm3.82 0v-3.06h.38v2.72h1.48v.34H94.1Zm3.05.05a.9.9 0 0 1-.39-.09.67.67 0 0 1-.27-.23.65.65 0 0 1-.1-.37c0-.14.03-.25.1-.35.06-.1.16-.17.28-.23.13-.05.28-.09.45-.1l.85-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.24-.13-.32-.08-.07-.21-.11-.38-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.28-.08.44-.08.19 0 .34.03.47.1.13.05.23.14.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.78.78 0 0 1-.41.33.9.9 0 0 1-.29.05Zm1.78-.05v-2.29h.37v.35h.03a.6.6 0 0 1 .24-.29.7.7 0 0 1 .38-.1c.1 0 .2.02.28.05.08.04.15.08.21.14.06.06.1.13.14.21h.04a.73.73 0 0 1 .4-.35c.1-.03.2-.05.3-.05.16 0 .29.03.4.09.1.06.19.14.25.25.05.11.08.25.08.41v1.58h-.37v-1.5c0-.1-.02-.2-.05-.28a.34.34 0 0 0-.16-.16.56.56 0 0 0-.27-.06c-.1 0-.2.02-.28.07a.5.5 0 0 0-.18.2.55.55 0 0 0-.07.26v1.47h-.37v-1.55c0-.1-.02-.17-.06-.24a.39.39 0 0 0-.16-.16.54.54 0 0 0-.25-.05c-.1 0-.2.03-.27.08a.56.56 0 0 0-.2.21.63.63 0 0 0-.06.3v1.41h-.37Zm4.93.05a.86.86 0 0 1-.54-.2.79.79 0 0 1-.18-.21h-.03v.36h-.37v-3.2h.37v1.27h.03a.79.79 0 0 1 .42-.35c.1-.03.2-.05.3-.05a.88.88 0 0 1 .84.56c.08.18.12.39.12.63s-.04.45-.12.63a.96.96 0 0 1-.34.4.88.88 0 0 1-.5.16Zm-.09-.33c.14 0 .26-.04.36-.1.1-.07.18-.17.23-.3.05-.13.08-.28.08-.46s-.03-.34-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.05.13-.08.28-.08.46s.03.33.08.46.13.22.23.3c.1.06.22.1.36.1Zm2.56.33c-.22 0-.4-.05-.56-.15a.95.95 0 0 1-.37-.4 1.45 1.45 0 0 1-.12-.63c0-.24.04-.45.12-.63a.97.97 0 0 1 .9-.57.93.93 0 0 1 .88.55c.09.17.13.37.13.6v.15h-1.84v-.3h1.65l-.19.27v-.15c0-.18-.02-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.61.61 0 0 0-.23.26 1 1 0 0 0-.08.43v.15c0 .16.02.3.08.42.06.11.13.2.24.26a.78.78 0 0 0 .63.05.6.6 0 0 0 .19-.1.4.4 0 0 0 .1-.14v-.02h.38v.02a.71.71 0 0 1-.11.23.86.86 0 0 1-.48.33c-.1.04-.23.06-.36.06Zm1.55-.05v-2.29h.37v.34h.03a.55.55 0 0 1 .23-.28c.1-.06.23-.1.39-.1a.9.9 0 0 1 .1 0l.08.02v.36a1.13 1.13 0 0 0-.22-.02.67.67 0 0 0-.32.06.54.54 0 0 0-.21.2.56.56 0 0 0-.08.3v1.41h-.37Zm2.52.02c-.24 0-.4-.05-.52-.14-.1-.1-.15-.25-.15-.47v-1.4h-.36v-.3h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .14.03.24.08.3s.13.08.25.08a1.88 1.88 0 0 0 .17 0v.31a2.08 2.08 0 0 1-.21.02Z"
            />
            <mask id="applicantTracker-g" fill={templateStyles['background']}>
              <path d="M72.18 113.69c0-.52.42-.93.93-.93h9.14c.51 0 .93.41.93.93v4.36c0 .51-.42.93-.93.93H73.1a.93.93 0 0 1-.93-.94v-4.35Z" />
            </mask>
            <path
              fill={tagBackgroundColors['purple']}
              d="M72.18 113.69c0-.52.42-.93.93-.93h9.14c.51 0 .93.41.93.93v4.36c0 .51-.42.93-.93.93H73.1a.93.93 0 0 1-.93-.94v-4.35Z"
            />
            <path
              fill={tagBackgroundColors['purple']}
              d="M73.11 112.76v1h9.14v-2H73.1v1Zm10.07.93h-1v4.36h2v-4.36h-1Zm-.93 5.29v-1H73.1v2h9.14v-1Zm-10.07-.94h1v-4.35h-2v4.36h1Zm.93.94v-1c.04 0 .07.03.07.06h-2c0 1.07.87 1.94 1.93 1.94v-1Zm10.07-.94h-1c0-.03.03-.06.07-.06v2c1.06 0 1.93-.87 1.93-1.94h-1Zm-.93-5.28v1a.07.07 0 0 1-.07-.07h2c0-1.07-.87-1.93-1.93-1.93v1Zm-9.14 0v-1c-1.06 0-1.93.86-1.93 1.93h2c0 .04-.03.07-.07.07v-1Z"
              mask="url(#applicantTracker-g)"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={74.64} y={117.02}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-1']
                )}
              </tspan>
            </text>
            <rect
              width={27.49}
              height={8.24}
              x={72.18}
              y={121.47}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M74.47 127.16c-.13 0-.25-.02-.35-.06a.75.75 0 0 1-.44-.4.94.94 0 0 1-.07-.3v-.04h.38v.02c.01.08.03.15.07.22.04.06.09.11.16.15.07.04.15.06.25.06.17 0 .3-.05.39-.15.09-.1.13-.24.13-.43v-2.21h.39v2.22c0 .19-.04.36-.11.5a.74.74 0 0 1-.31.31 1 1 0 0 1-.49.11Zm2.27-.03a.89.89 0 0 1-.39-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.15-.18.28-.23.12-.06.28-.1.45-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.11.27c0 .12.04.2.13.27.08.07.2.1.33.1.12 0 .24-.03.33-.08.1-.05.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.71c0-.14-.04-.25-.13-.32-.09-.08-.21-.12-.39-.12a.68.68 0 0 0-.33.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.27-.08.44-.08.18 0 .34.03.47.09.13.06.23.15.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.78.78 0 0 1-.41.34.92.92 0 0 1-.29.04Zm1.78-.04v-2.3h.37v.35h.03a.65.65 0 0 1 .25-.28c.11-.07.25-.1.42-.1.26 0 .45.07.6.22.13.14.2.35.2.62v1.49h-.37v-1.4c0-.2-.04-.36-.13-.46-.09-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.21.23.77.77 0 0 0-.07.34v1.36h-.37Zm3.76 0v-.27l1.04-1.12.3-.35c.08-.1.13-.18.16-.25a.66.66 0 0 0 .05-.25.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.33.08.53.53 0 0 0-.21.2.62.62 0 0 0-.08.32h-.36a.91.91 0 0 1 .48-.81c.15-.08.33-.12.52-.12.18 0 .34.03.48.11.15.07.26.17.34.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.11.22-.22.36-.1.13-.24.29-.43.48l-.8.82.1-.18v.18l-.09-.07h1.55v.35h-1.99Zm2.48.78.18-1.21h.42l-.33 1.2h-.27Zm2.6-.78v-.27l1.04-1.12c.13-.14.24-.26.3-.35.08-.1.13-.18.16-.25a.66.66 0 0 0 .05-.25.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.32.08.53.53 0 0 0-.22.2.62.62 0 0 0-.07.32h-.37a.91.91 0 0 1 .48-.81c.15-.08.33-.12.52-.12.18 0 .34.03.49.11.14.07.25.17.33.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.11.22-.21.36-.1.13-.25.29-.44.48l-.79.82.1-.18v.18l-.1-.07h1.55v.35h-1.98Zm3.66.07a.9.9 0 0 1-.58-.2 1.24 1.24 0 0 1-.37-.55 2.54 2.54 0 0 1-.13-.85c0-.34.04-.62.13-.86.08-.24.2-.43.37-.56a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.17.13.29.32.38.56.08.24.13.52.13.85 0 .33-.05.62-.13.86-.1.24-.21.42-.38.56a.9.9 0 0 1-.58.2Zm0-.33c.15 0 .27-.05.38-.16a1 1 0 0 0 .24-.44c.05-.19.08-.41.08-.67 0-.27-.03-.5-.08-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.38-.16.51.51 0 0 0-.38.16 1 1 0 0 0-.23.44c-.06.19-.09.41-.09.67 0 .27.03.5.09.68a1 1 0 0 0 .23.44c.1.1.23.16.38.16Zm1.72.26v-.27l1.04-1.12.3-.35c.08-.1.13-.18.16-.25a.66.66 0 0 0 .04-.25.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.61.61 0 0 0-.3-.07.65.65 0 0 0-.33.08.53.53 0 0 0-.22.2.62.62 0 0 0-.07.32h-.37a.91.91 0 0 1 .49-.81c.15-.08.32-.12.52-.12.17 0 .34.03.48.11.14.07.25.17.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.22-.21.36-.1.13-.25.29-.43.48l-.8.82.1-.18v.18l-.1-.07h1.55v.35h-1.98Zm3.63.07a1.1 1.1 0 0 1-.5-.11.92.92 0 0 1-.52-.75v-.02h.36v.02a.59.59 0 0 0 .35.45c.1.05.2.07.32.07a.65.65 0 0 0 .6-.34c.06-.1.09-.23.09-.36a.72.72 0 0 0-.1-.37.64.64 0 0 0-.59-.34c-.1 0-.2.02-.28.05a.67.67 0 0 0-.37.32h-.33l.16-1.76h1.71v.34h-1.4l-.1 1.04h.03c.04-.07.1-.13.16-.17a.88.88 0 0 1 .49-.14.94.94 0 0 1 .86.5c.09.14.13.32.13.52s-.04.39-.14.55a.97.97 0 0 1-.37.37 1.1 1.1 0 0 1-.56.13Z"
            />
            <rect
              width={49.71}
              height={8.24}
              x={72.18}
              y={132.2}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M75.91 134.3a2.02 2.02 0 1 0 1.01 3.77l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.8a.96.96 0 0 1-.79.41.69.69 0 0 1-.66-.44c-.36.42-.93.6-1.4.32-.56-.32-.65-1.06-.33-1.62s1.01-.85 1.57-.53a1.06 1.06 0 0 1 .5 1c0 .22.01.44.07.6.03.08.06.13.1.16.03.02.07.05.15.05a.5.5 0 0 0 .41-.23.9.9 0 0 0 .17-.5c0-1.13-.91-2.03-2.03-2.03Zm.67 1.9c0-.25-.1-.45-.28-.55-.27-.16-.7-.04-.93.36-.23.4-.11.83.15.99.27.15.7.04.93-.37a.91.91 0 0 0 .13-.4v-.03Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={79.65} y={137.48}>
                Christine Sanchez
              </tspan>
            </text>
          </g>
        </g>
        <g clipPath="url(#applicantTracker-h)">
          <rect
            width={60.19}
            height={216}
            x={130.4}
            y={4}
            fill={templateStyles['boardBackground']}
            rx={0.93}
          />
          <rect
            width={13.7}
            height={5.92}
            x={133.04}
            y={9.13}
            fill={tagBackgroundColors['blueLight']}
            rx={0.78}
          />
          <rect
            width={13.7}
            height={5.92}
            x={133.04}
            y={9.13}
            stroke={tagBorderColors['blueLight']}
            strokeWidth={0.3}
            rx={0.78}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={134.7} y={13.25}>
              {formatMessage(
                applicantTrackerMessages['applicant-tracker.field-2-select-option-3']
              )}
            </tspan>
          </text>
          <g filter="url(#applicantTracker-i)">
            <rect
              width={55.21}
              height={82.87}
              x={132.89}
              y={18.93}
              fill={templateStyles['background']}
              rx={1.24}
            />
            <rect
              width={38.71}
              height={8.24}
              x={135.38}
              y={22.67}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M139.12 24.77a2.02 2.02 0 1 0 1 3.77l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.8a.96.96 0 0 1-.78.4.68.68 0 0 1-.46-.15.78.78 0 0 1-.2-.28c-.36.41-.94.6-1.42.32-.55-.32-.64-1.06-.32-1.63.33-.56 1.02-.85 1.57-.53.35.2.51.58.5.97v.04c0 .21.02.43.07.6.03.08.07.13.1.15.03.03.08.05.16.05a.5.5 0 0 0 .4-.22.9.9 0 0 0 .17-.51c0-1.12-.9-2.02-2.02-2.02Zm.66 1.9c0-.25-.1-.46-.28-.55-.26-.16-.69-.05-.92.36-.24.4-.12.83.15.98.26.16.7.04.92-.36a.91.91 0 0 0 .13-.4v-.03Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="M144.13 28.29 143 25.22h.4l.9 2.57h.03l.9-2.57h.4l-1.12 3.07h-.38Zm2 0v-2.3h.38v2.3h-.37Zm.2-2.74a.25.25 0 0 1-.26-.26c0-.06.02-.12.07-.17a.25.25 0 0 1 .18-.08c.08 0 .14.03.19.08.04.05.07.1.07.18a.25.25 0 0 1-.26.25Zm1.81 2.78a.98.98 0 0 1-.92-.56 1.44 1.44 0 0 1-.13-.63c0-.25.04-.45.13-.63a.97.97 0 0 1 .92-.55c.19 0 .35.03.48.1a.86.86 0 0 1 .48.63h-.37a.52.52 0 0 0-.2-.29.62.62 0 0 0-.39-.12.61.61 0 0 0-.6.4c-.04.13-.07.28-.07.45 0 .18.03.34.08.47.06.12.13.22.23.3.1.07.22.1.36.1.16 0 .28-.03.38-.1.1-.06.17-.16.2-.29l.01-.01h.37v.02a.96.96 0 0 1-.17.37.8.8 0 0 1-.32.25c-.13.06-.28.09-.47.09Zm2.36-.02c-.24 0-.4-.05-.51-.15-.1-.1-.16-.25-.16-.47V26.3h-.36V26h.36v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.03.23.08.3.05.05.13.08.25.08a1.36 1.36 0 0 0 .17-.01v.31a2.68 2.68 0 0 1-.21.03Zm1.68.02c-.22 0-.4-.05-.56-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.64c0-.24.04-.46.13-.63a.96.96 0 0 1 .93-.55c.22 0 .4.04.56.14.16.1.28.23.37.4.08.18.13.4.13.64 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.14 0 .27-.03.37-.1.1-.07.17-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.47c.05.12.13.22.23.29.1.07.22.1.37.1Zm1.63.29v-2.3h.37v.35h.03a.54.54 0 0 1 .23-.28c.1-.07.23-.1.39-.1h.1l.08.01v.36a1.08 1.08 0 0 0-.23-.02.67.67 0 0 0-.3.07.54.54 0 0 0-.22.2.55.55 0 0 0-.08.29v1.42h-.37Zm1.67 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.19-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .19-.08c.07 0 .13.03.18.08.05.05.07.1.07.18a.24.24 0 0 1-.25.26Zm1.5 2.78a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.18.28-.23.13-.06.28-.1.46-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.21-.12-.38-.12a.68.68 0 0 0-.34.08.36.36 0 0 0-.18.2v.01h-.37v-.01a.62.62 0 0 1 .15-.32.8.8 0 0 1 .31-.2c.13-.06.28-.08.44-.08.19 0 .34.03.47.09.13.06.23.15.3.26.07.11.1.25.1.4v1.58h-.37v-.34h-.03a.77.77 0 0 1-.7.38Zm4.06.03c-.23 0-.42-.04-.6-.1a1 1 0 0 1-.39-.3.87.87 0 0 1-.17-.45v-.03h.39v.03c0 .1.05.19.11.26a.7.7 0 0 0 .28.18 1.18 1.18 0 0 0 .77 0c.1-.05.2-.12.25-.2.07-.07.1-.17.1-.27a.42.42 0 0 0-.14-.32.98.98 0 0 0-.46-.2l-.34-.08c-.3-.07-.53-.17-.67-.31a.75.75 0 0 1-.21-.55c0-.17.05-.33.14-.46.09-.13.22-.23.38-.3.16-.08.35-.11.56-.11.2 0 .39.03.54.1.16.08.28.18.38.3.09.13.14.26.15.42V26h-.38v-.03a.48.48 0 0 0-.11-.24.6.6 0 0 0-.24-.17.88.88 0 0 0-.35-.06.94.94 0 0 0-.34.06c-.1.04-.19.1-.25.17a.42.42 0 0 0-.09.27c0 .13.05.23.14.32.09.08.24.14.45.19l.34.08c.21.04.38.1.51.18.13.07.23.17.29.27.06.11.09.24.09.39 0 .2-.05.36-.14.5a.91.91 0 0 1-.4.32c-.17.07-.37.11-.6.11Zm2.53-.05c-.23 0-.4-.05-.5-.15-.11-.1-.16-.25-.16-.47V26.3h-.37V26h.37v-.6h.38v.6h.5v.3h-.5v1.3c0 .13.02.23.08.3.05.05.13.08.25.08a1.38 1.38 0 0 0 .17-.01v.31a2.97 2.97 0 0 1-.22.03Zm.97.78a.88.88 0 0 1-.16-.01v-.3H164.72c.1 0 .19-.02.25-.07a.56.56 0 0 0 .17-.28l.04-.14-.85-2.3h.4l.7 2.12-.14-.23h.17l-.14.23.7-2.11h.39l-.9 2.43c-.06.17-.13.3-.2.4a.57.57 0 0 1-.24.2c-.1.04-.2.06-.34.06Zm2.19-.8v-3.2h.37v3.2h-.37Zm2.02.04c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.46 1.46 0 0 1-.13-.63c0-.24.05-.45.13-.62a.97.97 0 0 1 .9-.57c.21 0 .39.04.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.83v-.3h1.64l-.18.27v-.14c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.62.62 0 0 0-.23.26 1 1 0 0 0-.09.44v.14c0 .17.03.3.09.42.05.12.13.2.23.27.1.06.22.09.36.09.1 0 .2-.01.27-.04a.58.58 0 0 0 .2-.11.38.38 0 0 0 .1-.14v-.01h.38v.01a.71.71 0 0 1-.11.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.37.05Zm2.34 0c-.18 0-.33-.03-.46-.08a.8.8 0 0 1-.31-.22.6.6 0 0 1-.14-.33h.38c.03.1.1.18.18.23a.76.76 0 0 0 .63.04.47.47 0 0 0 .19-.12.28.28 0 0 0 .06-.18.25.25 0 0 0-.09-.2.72.72 0 0 0-.3-.14l-.36-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.07-.28c0-.13.03-.25.1-.35.08-.1.19-.18.31-.24.13-.06.28-.08.44-.08.16 0 .3.02.43.07.12.05.22.12.3.21.07.1.12.2.13.33h-.36a.38.38 0 0 0-.16-.22.61.61 0 0 0-.34-.09c-.1 0-.17.02-.25.05a.4.4 0 0 0-.16.12.28.28 0 0 0-.06.18c0 .05 0 .1.04.14.02.04.06.07.12.1s.13.06.22.08l.35.08c.22.06.38.13.48.23.11.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.14.06-.3.09-.47.09Z"
            />
            <rect
              width={41.7}
              height={5.92}
              x={135.53}
              y={33.55}
              fill={tagBackgroundColors['teal']}
              rx={0.78}
            />
            <rect
              width={41.7}
              height={5.92}
              x={135.53}
              y={33.55}
              stroke={tagBackgroundColors['teal']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={137} y={37.67}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-5']
                )}
              </tspan>
            </text>
            <rect
              width={26.49}
              height={8.24}
              x={135.38}
              y={42.11}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M137.68 47.8c-.14 0-.26-.01-.36-.05a.75.75 0 0 1-.43-.4.92.92 0 0 1-.08-.31V47h.38v.02c.01.07.04.14.07.21.04.06.1.12.16.16a.5.5 0 0 0 .25.05c.17 0 .3-.05.4-.14.08-.1.13-.25.13-.43v-2.22h.38v2.22c0 .2-.04.36-.11.5a.73.73 0 0 1-.3.32 1 1 0 0 1-.5.1Zm2.26-.03a.9.9 0 0 1-.39-.08.67.67 0 0 1-.27-.24.64.64 0 0 1-.1-.36.6.6 0 0 1 .1-.35c.06-.1.16-.17.28-.23.13-.05.28-.09.45-.1l.85-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08a.6.6 0 0 0 .23-.2.53.53 0 0 0 .08-.3v-.72c0-.14-.04-.25-.13-.32-.08-.07-.21-.11-.38-.11a.68.68 0 0 0-.34.07.36.36 0 0 0-.18.2v.02h-.37V46a.62.62 0 0 1 .15-.31.8.8 0 0 1 .31-.21c.13-.05.28-.08.44-.08.19 0 .34.03.47.1.13.05.23.14.3.26.07.1.1.25.1.4v1.57h-.37v-.33h-.03a.78.78 0 0 1-.41.33.9.9 0 0 1-.29.04Zm1.78-.04v-2.29h.37v.35h.03a.65.65 0 0 1 .25-.29c.11-.07.25-.1.42-.1.26 0 .46.07.6.22.13.15.2.36.2.63v1.48h-.37v-1.4c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.54.54 0 0 0-.21.22.77.77 0 0 0-.07.35v1.35h-.37Zm4.52 0V45.1h-.04l-.78.57v-.4l.82-.6h.38v3.07h-.38Zm1.07.78.18-1.2h.42l-.33 1.2h-.27Zm2.6-.78v-.26l1.04-1.12.31-.35c.07-.1.13-.18.16-.26a.66.66 0 0 0 .04-.24c0-.12-.02-.21-.07-.3a.5.5 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.32.07.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.51-.13.18 0 .34.04.49.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17v.17l-.1-.06h1.55v.34h-1.98Zm3.66.08a.9.9 0 0 1-.58-.2 1.23 1.23 0 0 1-.37-.55 2.52 2.52 0 0 1-.13-.86c0-.33.04-.62.13-.86s.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .59.2c.16.13.28.31.37.55.09.24.13.53.13.86 0 .33-.04.61-.13.85s-.21.43-.38.56a.9.9 0 0 1-.58.2Zm0-.34c.15 0 .28-.05.38-.15a1 1 0 0 0 .24-.44c.06-.2.08-.42.08-.68 0-.27-.02-.49-.08-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.37.15c-.1.1-.19.25-.24.44-.06.19-.09.41-.09.68 0 .26.03.49.09.68a1 1 0 0 0 .24.44c.1.1.23.15.37.15Zm1.72.26v-.26l1.04-1.12.3-.35c.08-.1.13-.18.16-.26a.66.66 0 0 0 .04-.24.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.62.62 0 0 0-.3-.07.65.65 0 0 0-.33.07.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.52-.13.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17v.17l-.1-.06h1.56v.34h-2Zm3.64.08c-.2 0-.36-.04-.51-.12a.92.92 0 0 1-.52-.75v-.02h.37v.02c.01.1.05.19.1.27.06.08.14.14.24.19.1.04.2.07.32.07a.65.65 0 0 0 .6-.34c.06-.1.09-.23.09-.37a.72.72 0 0 0-.1-.36.63.63 0 0 0-.23-.25.69.69 0 0 0-.35-.1c-.1 0-.2.02-.29.05a.66.66 0 0 0-.3.23.74.74 0 0 0-.06.1h-.34l.17-1.77h1.7v.35h-1.4l-.1 1.03h.03c.04-.06.1-.12.16-.17a.9.9 0 0 1 .49-.14.94.94 0 0 1 .86.5c.1.15.13.32.13.52 0 .21-.04.4-.14.55a.97.97 0 0 1-.37.37c-.16.1-.35.14-.55.14Z"
            />
            <rect
              width={28.71}
              height={8.24}
              x={135.38}
              y={52.84}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M139.12 54.94a2.02 2.02 0 1 0 1 3.78l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.79a.96.96 0 0 1-.78.42.69.69 0 0 1-.66-.44c-.36.41-.94.59-1.42.31-.55-.31-.64-1.06-.32-1.62.33-.56 1.02-.85 1.57-.53.35.2.51.58.5.97v.04c0 .2.02.43.07.6.03.07.07.12.1.15s.08.05.16.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.28-.55-.26-.15-.69-.04-.92.37-.24.4-.12.83.15.98.26.15.7.04.92-.36a.91.91 0 0 0 .13-.4v-.04Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={142.85} y={58.13}>
                Brian Lin
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={135.38} y={68.24}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-4-cell-6']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={135.38} y={77.73}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-4-cell-7']
                ).substring(0, 20)}
              </tspan>
              <tspan x={134.38} y={83.95}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-4-cell-7']
                ).substring(20, 44)}
              </tspan>
              <tspan x={134.38} y={90.17}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-4-cell-7']
                ).substring(44, 56)}
              </tspan>
              <tspan x={134.38} y={96.39}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-4-cell-7']
                ).substring(56)}
              </tspan>
            </text>
          </g>
          <path
            fill={templateStyles['icon']}
            fillRule="evenodd"
            d="M149.01 111.07V113h.47v-1.94h1.95v-.47h-1.95v-1.94h-.47v1.94h-1.94v.47H149Z"
            clipRule="evenodd"
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            fontWeight={510}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={153.24} y={111.99}>
              {formatMessage(messages['templates-preview.add-entry'])}
            </tspan>
          </text>
        </g>
        <g clipPath="url(#applicantTracker-j)">
          <rect
            width={60.19}
            height={216}
            x={193.61}
            y={4}
            fill={templateStyles['boardBackground']}
            rx={0.93}
          />
          <rect
            width={35.7}
            height={5.92}
            x={196.25}
            y={9.13}
            fill={tagBackgroundColors['purpleLight']}
            rx={0.78}
          />
          <rect
            width={35.7}
            height={5.92}
            x={196.25}
            y={9.13}
            stroke={tagBorderColors['purpleLight']}
            strokeWidth={0.3}
            rx={0.78}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={197.55} y={13.25}>
              {formatMessage(
                applicantTrackerMessages['applicant-tracker.field-2-select-option-4']
              )}
            </tspan>
          </text>
          <g filter="url(#applicantTracker-k)">
            <rect
              width={55.21}
              height={76.87}
              x={196.1}
              y={18.93}
              fill={templateStyles['background']}
              rx={1.24}
            />
            <rect
              width={34.71}
              height={8.24}
              x={198.58}
              y={22.67}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M202.32 24.77a2.02 2.02 0 1 0 1 3.77l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.8a.96.96 0 0 1-.78.4.69.69 0 0 1-.66-.43c-.36.41-.94.6-1.41.32-.56-.32-.65-1.06-.32-1.63.32-.56 1-.85 1.56-.53.35.2.52.58.5.97v.04c0 .21.02.43.08.6.02.08.06.13.1.15.03.03.07.05.15.05a.5.5 0 0 0 .4-.22.9.9 0 0 0 .17-.51c0-1.12-.9-2.02-2.02-2.02Zm.66 1.9c0-.25-.1-.46-.27-.55-.27-.16-.7-.05-.93.36-.24.4-.12.83.15.98.27.16.7.04.93-.36a.92.92 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="M206.44 28.29v-3.07h1.87v.34h-1.49v1.06h1.36v.34h-1.36v1.33h-.38Zm2.46 0v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.18-.07.25.25 0 0 1-.07-.18c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.08.1.08.18a.25.25 0 0 1-.26.25Zm1.73 2.78a.88.88 0 0 1-.84-.56 1.52 1.52 0 0 1-.12-.63c0-.24.04-.45.12-.62a.96.96 0 0 1 .33-.42c.15-.1.32-.14.51-.14a.84.84 0 0 1 .54.19c.08.05.13.13.18.2h.03V25.1h.37v3.2h-.37v-.37h-.03a.77.77 0 0 1-.72.4Zm.09-.33c.13 0 .25-.03.35-.1.1-.07.18-.17.24-.3.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.66.66 0 0 0-.24-.3.61.61 0 0 0-.35-.1.62.62 0 0 0-.36.1.65.65 0 0 0-.23.3 1.2 1.2 0 0 0-.08.46c0 .18.02.34.08.46.05.13.13.23.23.3.1.07.22.1.36.1Zm2.67.33c-.21 0-.4-.05-.56-.15a.96.96 0 0 1-.36-.4 1.46 1.46 0 0 1-.13-.63c0-.24.05-.45.13-.62a.97.97 0 0 1 .9-.57c.21 0 .39.04.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.83v-.3h1.64l-.18.27v-.14c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.62.62 0 0 0-.33.09.62.62 0 0 0-.23.26 1 1 0 0 0-.09.44v.14c0 .17.03.3.09.42.05.12.13.2.23.27.1.06.22.09.36.09.1 0 .2-.01.27-.04a.58.58 0 0 0 .2-.11.4.4 0 0 0 .1-.14v-.01h.38v.01a.7.7 0 0 1-.11.23.87.87 0 0 1-.48.34c-.1.03-.23.05-.37.05Zm1.58-.04v-3.2h.37v3.2h-.37Zm1.09 0v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.19-.07.25.25 0 0 1-.07-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.07.1.07.18a.25.25 0 0 1-.26.26Zm1.66 2.78c-.17 0-.32-.03-.45-.08a.78.78 0 0 1-.31-.22.6.6 0 0 1-.14-.33h.38c.03.1.09.18.18.23.1.06.2.1.35.1.1 0 .2-.02.28-.05a.47.47 0 0 0 .19-.13.28.28 0 0 0 .06-.18.25.25 0 0 0-.1-.2.72.72 0 0 0-.3-.14l-.35-.09a1.3 1.3 0 0 1-.35-.13.55.55 0 0 1-.2-.2.59.59 0 0 1-.08-.28c0-.13.04-.25.12-.35.07-.1.17-.18.3-.24.13-.06.28-.08.44-.08.16 0 .3.02.42.07.13.05.23.12.3.21.08.1.13.2.14.33h-.36a.38.38 0 0 0-.17-.22.61.61 0 0 0-.34-.09.62.62 0 0 0-.24.05.4.4 0 0 0-.17.12.28.28 0 0 0-.06.18c0 .05.02.1.04.14.03.04.07.07.13.1s.13.06.22.08l.35.08c.22.06.38.13.48.23.1.1.16.23.16.4 0 .13-.04.25-.12.36a.8.8 0 0 1-.33.24c-.14.06-.3.09-.47.09Zm2.77-.04v-3.07h1.9v.34h-1.52v.99h1.44v.34h-1.44v1.05h1.52v.35h-1.9Zm2.22.79H223v-.33h.06c.12 0 .21-.03.26-.08.05-.05.08-.14.08-.26V26h.37v2.4c0 .24-.06.4-.17.51-.11.11-.3.17-.53.17Zm.52-3.53a.25.25 0 0 1-.18-.07.25.25 0 0 1-.08-.18c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.07.1.07.18 0 .07-.02.13-.07.18a.24.24 0 0 1-.18.07Zm.89 2.74v-2.3h.37v2.3h-.37Zm.19-2.74a.25.25 0 0 1-.26-.25c0-.07.03-.13.08-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.18.08.05.05.07.1.07.18a.25.25 0 0 1-.25.25Zm.88 2.74v-2.3h.37v.36h.03a.6.6 0 0 1 .24-.3.7.7 0 0 1 .38-.1c.1 0 .2.02.28.06.08.03.15.08.21.14.06.06.1.13.14.2h.04c.04-.07.1-.14.16-.2.07-.06.15-.11.24-.14.1-.04.2-.05.3-.05.16 0 .29.02.4.08.1.06.19.15.24.26.06.1.09.24.09.4v1.59h-.37v-1.5c0-.11-.02-.2-.05-.28a.34.34 0 0 0-.16-.17.56.56 0 0 0-.27-.06c-.1 0-.2.03-.28.08a.5.5 0 0 0-.18.19.54.54 0 0 0-.07.27v1.47h-.37v-1.56c0-.09-.02-.17-.06-.23a.39.39 0 0 0-.16-.16.54.54 0 0 0-.25-.06c-.1 0-.2.03-.28.08a.55.55 0 0 0-.18.21.62.62 0 0 0-.07.3v1.42h-.37Zm4.42.04a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36c0-.14.03-.26.1-.35.06-.1.16-.18.28-.23.13-.06.28-.1.46-.1l.84-.05v.3l-.8.04a.7.7 0 0 0-.38.11.32.32 0 0 0-.12.27c0 .12.04.2.13.27s.2.1.33.1.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.71c0-.14-.04-.25-.13-.32-.08-.08-.2-.12-.38-.12a.69.69 0 0 0-.34.08.36.36 0 0 0-.17.2v.01h-.38v-.01a.61.61 0 0 1 .15-.32.8.8 0 0 1 .32-.2c.12-.06.27-.08.43-.08.19 0 .35.03.48.09s.23.15.3.26c.06.11.1.25.1.4v1.58h-.38v-.34h-.03a.78.78 0 0 1-.4.34.92.92 0 0 1-.3.04Z"
            />
            <rect
              width={41.7}
              height={5.92}
              x={198.73}
              y={33.55}
              fill={tagBackgroundColors['teal']}
              rx={0.78}
            />
            <rect
              width={41.7}
              height={5.92}
              x={198.73}
              y={33.55}
              stroke={tagBorderColors['teal']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={200} y={37.67}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-5']
                )}
              </tspan>
            </text>
            <rect
              width={30.49}
              height={8.24}
              x={198.58}
              y={42.11}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M200.22 47.73v-3.07h1.05c.3 0 .57.07.78.19.22.12.38.3.5.52.11.23.17.5.17.83 0 .32-.06.6-.17.83-.12.23-.28.4-.5.52-.21.12-.47.18-.78.18h-1.05Zm.38-.34h.65c.23 0 .42-.05.58-.14.16-.1.29-.23.37-.4.09-.18.13-.4.13-.65s-.04-.46-.13-.64a.9.9 0 0 0-.37-.4c-.16-.1-.36-.15-.58-.15h-.65v2.38Zm3.67.38c-.22 0-.4-.04-.56-.14a.96.96 0 0 1-.36-.4 1.45 1.45 0 0 1-.13-.63c0-.24.04-.45.13-.63a1 1 0 0 1 .36-.42c.15-.1.33-.15.54-.15a.93.93 0 0 1 .88.55c.08.17.12.37.12.6v.14h-1.84v-.3h1.65l-.18.28v-.15c0-.18-.03-.33-.08-.44a.57.57 0 0 0-.55-.35.62.62 0 0 0-.33.1.61.61 0 0 0-.23.26.99.99 0 0 0-.09.43v.15c0 .16.03.3.09.42a.62.62 0 0 0 .6.35c.1 0 .19-.01.26-.04a.6.6 0 0 0 .2-.1.4.4 0 0 0 .1-.14v-.02h.37v.02a.7.7 0 0 1-.1.22.85.85 0 0 1-.2.2.98.98 0 0 1-.28.14c-.11.04-.23.05-.37.05Zm2.5 0c-.22 0-.4-.05-.56-.14a.98.98 0 0 1-.37-.42 1.44 1.44 0 0 1-.13-.63c0-.24.04-.45.13-.62a.97.97 0 0 1 .92-.56c.19 0 .35.03.48.1a.86.86 0 0 1 .48.63v.01h-.37a.53.53 0 0 0-.19-.3.63.63 0 0 0-.4-.11.61.61 0 0 0-.59.4c-.05.12-.08.27-.08.45s.03.33.08.46c.06.13.14.23.24.3.1.07.22.1.35.1.16 0 .28-.03.38-.1.1-.06.17-.16.21-.29l.37-.01v.02a.98.98 0 0 1-.17.37.8.8 0 0 1-.31.25c-.13.06-.3.1-.48.1Zm2.72-.04v-.26l1.03-1.12.31-.35c.07-.1.13-.18.16-.26a.68.68 0 0 0 .04-.24c0-.12-.02-.21-.07-.3a.52.52 0 0 0-.2-.2.61.61 0 0 0-.31-.07.65.65 0 0 0-.32.07.52.52 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.92.92 0 0 1 .48-.82c.16-.08.33-.12.53-.12.17 0 .34.04.48.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17v.17l-.1-.06h1.55v.34h-1.98Zm3.67.05c-.21 0-.4-.03-.55-.1a.94.94 0 0 1-.38-.3.85.85 0 0 1-.16-.43v-.03h.37v.02c.01.1.05.2.1.27.07.07.15.13.26.18.1.04.22.06.36.06.13 0 .25-.02.35-.07.1-.04.18-.1.24-.2a.5.5 0 0 0 .09-.28.52.52 0 0 0-.2-.44.78.78 0 0 0-.5-.15h-.39V46h.37c.12 0 .23-.03.32-.07.1-.05.17-.11.22-.19a.49.49 0 0 0 .08-.27c0-.12-.02-.2-.07-.28a.44.44 0 0 0-.2-.18.76.76 0 0 0-.31-.05.8.8 0 0 0-.33.06c-.1.04-.17.1-.22.17a.54.54 0 0 0-.1.27v.02h-.38v-.02a.9.9 0 0 1 .16-.44.9.9 0 0 1 .36-.3c.14-.06.31-.1.5-.1.2 0 .37.04.51.1a.8.8 0 0 1 .34.28c.08.12.13.26.13.41a.67.67 0 0 1-.32.59.96.96 0 0 1-.34.14c.23.02.4.1.55.23.13.14.2.31.2.53 0 .17-.04.33-.13.46a.95.95 0 0 1-.38.32c-.16.08-.34.11-.55.11Zm1.44.73.19-1.2h.42l-.33 1.2h-.28Zm2.62-.78v-.26l1.03-1.12c.13-.15.24-.26.3-.35.08-.1.13-.18.16-.26a.66.66 0 0 0 .05-.24c0-.12-.02-.21-.07-.3a.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.07.65.65 0 0 0-.32.07.53.53 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .48-.82c.16-.08.33-.12.52-.12.18 0 .34.04.49.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.44.48l-.79.82.1-.17v.17l-.1-.06h1.55v.34h-1.98Zm3.65.08a.9.9 0 0 1-.58-.2 1.23 1.23 0 0 1-.37-.55 2.55 2.55 0 0 1-.13-.86c0-.33.04-.62.13-.86.08-.24.2-.42.37-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.17.13.29.31.38.55.08.24.13.53.13.86 0 .33-.05.61-.13.85-.1.24-.22.43-.38.56a.9.9 0 0 1-.58.2Zm0-.34c.15 0 .27-.05.38-.15a1 1 0 0 0 .24-.44c.05-.2.08-.42.08-.68 0-.27-.03-.49-.08-.68a.99.99 0 0 0-.24-.44.51.51 0 0 0-.38-.15.52.52 0 0 0-.38.15 1 1 0 0 0-.23.44c-.06.19-.09.41-.09.68 0 .26.03.49.09.68.05.19.13.33.23.44.1.1.23.15.38.15Zm1.72.26v-.26l1.03-1.12.31-.35c.07-.1.13-.18.16-.26a.66.66 0 0 0 .04-.24c0-.12-.02-.21-.07-.3a.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.07.65.65 0 0 0-.32.07.53.53 0 0 0-.22.21.61.61 0 0 0-.07.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.17 0 .34.04.48.11.14.08.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17v.17l-.1-.06h1.55v.34h-1.98Zm3.96 0v-.63h-1.5v-.35a76.59 76.59 0 0 1 .52-.85c.1-.14.18-.28.27-.43a54.67 54.67 0 0 1 .53-.8h.56v2.09h.43v.34h-.43v.63h-.38Zm-1.1-.97h1.1v-1.74h-.02l-.21.32-.22.34-.22.35a33.86 33.86 0 0 0-.43.7v.03Z"
            />
            <rect
              width={28.71}
              height={8.24}
              x={198.58}
              y={52.84}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M202.32 54.94a2.02 2.02 0 1 0 1 3.78l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.79a.96.96 0 0 1-.78.42.69.69 0 0 1-.66-.44c-.36.41-.94.59-1.41.31-.56-.31-.65-1.06-.32-1.62.32-.56 1-.85 1.56-.53a1.07 1.07 0 0 1 .5 1c0 .22.02.44.08.6.02.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.27-.55-.27-.15-.7-.04-.93.37-.24.4-.12.83.15.98.27.15.7.04.93-.36a.93.93 0 0 0 .12-.4v-.04Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={206.05} y={58.13}>
                Brian Lin
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={198.58} y={68.24}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-5-cell-6']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={198.58} y={77.73}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-5-cell-7']
                ).substring(0, 19)}
              </tspan>
              <tspan x={198.58} y={83.95}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-5-cell-7']
                ).substring(19, 41)}
              </tspan>
              <tspan x={197.58} y={90.17}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-5-cell-7']
                ).substring(41)}
              </tspan>
            </text>
          </g>
          <g filter="url(#applicantTracker-l)">
            <rect
              width={55.21}
              height={118.36}
              x={196.1}
              y={98.29}
              fill={templateStyles['background']}
              rx={1.24}
            />
            <rect
              width={32.71}
              height={8.24}
              x={198.58}
              y={102.02}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M202.32 104.12a2.02 2.02 0 1 0 1 3.78l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.79a.96.96 0 0 1-.78.41.69.69 0 0 1-.66-.44c-.36.42-.94.6-1.41.32-.56-.32-.65-1.06-.32-1.62.32-.56 1-.85 1.56-.53a1.07 1.07 0 0 1 .5 1c0 .22.02.44.08.6.02.08.06.13.1.16.03.03.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.27-.55-.27-.15-.7-.04-.93.36-.24.4-.12.83.15.99.27.15.7.04.93-.36a.93.93 0 0 0 .12-.4v-.04Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="M207.73 107.72a1.3 1.3 0 0 1-1.24-.75 2 2 0 0 1-.17-.86c0-.33.06-.62.17-.86.12-.24.28-.42.49-.55.21-.13.46-.2.75-.2.3 0 .54.07.75.2.21.13.38.31.49.56.11.24.17.52.17.85 0 .33-.06.61-.17.85a1.28 1.28 0 0 1-1.24.76Zm0-.36c.21 0 .4-.05.54-.15a1 1 0 0 0 .35-.44c.09-.19.13-.4.13-.66s-.04-.48-.13-.67a.99.99 0 0 0-.35-.43.95.95 0 0 0-.54-.15c-.2 0-.39.05-.54.15a1 1 0 0 0-.35.43c-.08.19-.13.41-.13.67 0 .25.04.47.13.66.08.19.2.34.34.44.16.1.34.15.55.15Zm2.03.28v-2.29h.37v.35h.03a.61.61 0 0 1 .23-.29.7.7 0 0 1 .39-.1c.1 0 .2.02.28.05.08.04.15.08.21.14.06.06.1.13.14.21h.04a.74.74 0 0 1 .4-.35c.1-.03.2-.05.3-.05.15 0 .29.03.4.09.1.06.19.14.24.25.06.11.09.25.09.41v1.58h-.37v-1.5c0-.1-.02-.2-.05-.28a.34.34 0 0 0-.16-.16.56.56 0 0 0-.27-.06.5.5 0 0 0-.46.27.54.54 0 0 0-.07.26v1.47h-.37v-1.55c0-.1-.02-.17-.06-.24a.38.38 0 0 0-.17-.16.53.53 0 0 0-.25-.05c-.1 0-.19.03-.27.08a.56.56 0 0 0-.19.21.64.64 0 0 0-.06.3v1.41h-.37Zm4.42.05a.9.9 0 0 1-.4-.09.67.67 0 0 1-.27-.23.64.64 0 0 1-.1-.37c0-.14.03-.25.1-.35.06-.1.16-.17.28-.23.13-.05.28-.09.46-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.32.32 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.24-.13-.32-.08-.07-.21-.11-.38-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.62.62 0 0 1 .15-.32.8.8 0 0 1 .31-.21c.13-.05.28-.08.44-.08.19 0 .35.03.47.1.13.05.23.14.3.26.07.11.1.25.1.4v1.57h-.37v-.33h-.03a.8.8 0 0 1-.18.2.72.72 0 0 1-.23.13.89.89 0 0 1-.28.05Zm1.77-.05v-2.29h.37v.34h.03a.55.55 0 0 1 .23-.28c.1-.06.23-.1.38-.1a.9.9 0 0 1 .11 0l.08.02v.36a1.17 1.17 0 0 0-.23-.03.67.67 0 0 0-.31.08.54.54 0 0 0-.21.19.55.55 0 0 0-.08.3v1.41h-.37Zm3.94.08c-.23 0-.42-.04-.6-.11a.99.99 0 0 1-.39-.3.86.86 0 0 1-.16-.45v-.02h.38v.02c0 .1.05.2.12.27a.7.7 0 0 0 .27.17 1.18 1.18 0 0 0 .77 0c.1-.05.2-.11.25-.19.07-.08.1-.17.1-.27a.42.42 0 0 0-.14-.33.97.97 0 0 0-.46-.2l-.34-.07c-.3-.07-.53-.18-.67-.32a.76.76 0 0 1-.21-.55c0-.17.05-.32.14-.45.09-.13.22-.23.38-.3.16-.08.35-.12.56-.12.2 0 .39.04.54.11.16.08.28.17.38.3.09.12.14.26.15.41v.03h-.38v-.03a.47.47 0 0 0-.11-.24.6.6 0 0 0-.24-.16.9.9 0 0 0-.35-.06.94.94 0 0 0-.34.06c-.1.04-.19.1-.25.17a.42.42 0 0 0-.09.27c0 .12.05.23.14.31.09.08.24.15.45.2l.34.07c.21.05.38.1.51.18.13.08.23.17.29.28.06.1.09.24.09.38 0 .2-.05.36-.14.5a.92.92 0 0 1-.4.32c-.17.08-.37.12-.6.12Zm2.35-.03a.9.9 0 0 1-.4-.09.68.68 0 0 1-.27-.23.64.64 0 0 1-.1-.37c0-.14.04-.25.1-.35.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.69.69 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.05.21.14.28.08.06.2.1.33.1.12 0 .24-.03.33-.08.1-.05.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.72c0-.14-.05-.24-.13-.32-.09-.07-.22-.11-.39-.11a.7.7 0 0 0-.34.07.36.36 0 0 0-.17.21h-.37a.62.62 0 0 1 .15-.32.8.8 0 0 1 .3-.21c.14-.05.28-.08.44-.08.2 0 .35.03.48.1.13.05.23.14.3.26.06.11.1.25.1.4v1.57h-.37v-.33h-.04a.73.73 0 0 1-.4.34.9.9 0 0 1-.29.03Zm1.8-.05v-3.2h.37v3.2h-.38Zm1.7.05a.9.9 0 0 1-.39-.09.68.68 0 0 1-.27-.23.64.64 0 0 1-.1-.37c0-.14.03-.25.1-.35.06-.1.16-.17.28-.23.13-.05.28-.09.45-.1l.85-.05v.3l-.8.05a.69.69 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.04.21.13.28.09.06.2.1.33.1s.24-.03.34-.08c.1-.05.17-.12.23-.2a.52.52 0 0 0 .08-.3v-.72c0-.14-.04-.24-.13-.32-.08-.07-.21-.11-.38-.11a.7.7 0 0 0-.34.07.36.36 0 0 0-.18.21h-.37a.61.61 0 0 1 .15-.32.82.82 0 0 1 .31-.21c.13-.05.28-.08.44-.08.19 0 .34.03.47.1.13.05.23.14.3.26.07.11.1.25.1.4v1.57h-.37v-.33h-.03a.77.77 0 0 1-.7.38Zm1.8-.05v-3.2h.37v1.26h.03a.65.65 0 0 1 .25-.29c.11-.06.25-.1.42-.1.17 0 .32.03.44.1s.2.16.27.29c.06.13.1.28.1.46v1.48h-.38v-1.4c0-.2-.04-.35-.13-.45-.09-.1-.22-.15-.4-.15a.61.61 0 0 0-.32.08.53.53 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Z"
            />
            <mask id="applicantTracker-m" fill={templateStyles['background']}>
              <path d="M198.58 113.69c0-.52.42-.93.94-.93h39.13c.52 0 .93.41.93.93v4.36c0 .51-.41.93-.93.93h-39.13a.93.93 0 0 1-.94-.94v-4.35Z" />
            </mask>
            <path
              fill={tagBackgroundColors['red']}
              d="M198.58 113.69c0-.52.42-.93.94-.93h39.13c.52 0 .93.41.93.93v4.36c0 .51-.41.93-.93.93h-39.13a.93.93 0 0 1-.94-.94v-4.35Z"
            />
            <path
              fill={tagBackgroundColors['red']}
              d="M199.52 112.76v1h39.13v-2h-39.13v1Zm40.06.93h-1v4.36h2v-4.36h-1Zm-.93 5.29v-1h-39.13v2h39.13v-1Zm-40.07-.94h1v-4.35h-2v4.36h1Zm.94.94v-1c.03 0 .06.03.06.06h-2c0 1.07.87 1.94 1.94 1.94v-1Zm40.06-.94h-1c0-.03.03-.06.07-.06v2c1.07 0 1.93-.87 1.93-1.94h-1Zm-.93-5.28v1a.07.07 0 0 1-.07-.07h2c0-1.07-.86-1.93-1.93-1.93v1Zm-39.13 0v-1c-1.07 0-1.94.86-1.94 1.93h2c0 .04-.03.07-.06.07v-1Z"
              mask="url(#applicantTracker-m)"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={200} y={117.02}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-3']
                )}
              </tspan>
            </text>
            <rect
              width={30.49}
              height={8.24}
              x={198.58}
              y={121.47}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M200.22 127.09v-3.07h1.05c.3 0 .57.06.78.18.22.12.38.3.5.53.11.22.17.5.17.82 0 .33-.06.6-.17.83-.12.23-.28.4-.5.53-.21.12-.47.18-.78.18h-1.05Zm.38-.35h.65c.23 0 .42-.04.58-.14a.9.9 0 0 0 .37-.4c.09-.18.13-.4.13-.64 0-.25-.04-.47-.13-.64a.91.91 0 0 0-.37-.41c-.16-.1-.36-.15-.58-.15h-.65v2.38Zm3.67.39c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.36-.41 1.44 1.44 0 0 1-.13-.63c0-.24.04-.45.13-.62a.97.97 0 0 1 .9-.57c.2 0 .39.04.54.14.15.1.26.23.34.4.08.18.12.38.12.6v.15h-1.84v-.3h1.65l-.18.27v-.14c0-.18-.03-.33-.08-.45a.57.57 0 0 0-.55-.34.62.62 0 0 0-.33.09.61.61 0 0 0-.23.26 1 1 0 0 0-.09.44v.14c0 .17.03.3.09.42a.61.61 0 0 0 .6.36c.1 0 .19-.01.26-.04a.59.59 0 0 0 .2-.11.41.41 0 0 0 .1-.14v-.01h.37v.01a.7.7 0 0 1-.1.23.84.84 0 0 1-.2.2.97.97 0 0 1-.28.14c-.11.03-.23.05-.37.05Zm2.5 0a.98.98 0 0 1-.92-.56 1.44 1.44 0 0 1-.14-.63c0-.25.04-.45.13-.63.09-.17.2-.31.37-.4.15-.1.34-.15.55-.15.19 0 .35.03.48.1a.85.85 0 0 1 .48.63h-.37a.52.52 0 0 0-.19-.29.62.62 0 0 0-.4-.12.6.6 0 0 0-.35.1.67.67 0 0 0-.24.3c-.05.13-.08.28-.08.45 0 .18.03.33.08.47.06.13.14.22.24.3.1.07.22.1.35.1.16 0 .28-.03.38-.1.1-.06.17-.16.21-.29v-.01h.37v.02a.98.98 0 0 1-.17.37.81.81 0 0 1-.31.25c-.13.06-.3.09-.48.09Zm3.47-.04v-2.65h-.04l-.78.57v-.4l.82-.59h.38v3.07h-.38Zm1.27 0v-.27l1.03-1.12c.14-.14.24-.26.31-.35.08-.1.13-.18.16-.25a.66.66 0 0 0 .04-.25.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.07.65.65 0 0 0-.32.08.53.53 0 0 0-.22.2.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .49-.81c.15-.08.32-.12.52-.12.17 0 .34.03.48.11.14.07.25.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.11.22-.21.36-.1.13-.25.29-.43.48l-.8.82.1-.18v.18l-.1-.07h1.55v.35h-1.98Zm2.47.78.19-1.21h.42l-.34 1.21h-.27Zm2.61-.78v-.27l1.04-1.12.3-.35c.08-.1.13-.18.16-.25a.66.66 0 0 0 .04-.25c0-.11-.02-.2-.07-.3a.52.52 0 0 0-.2-.2.62.62 0 0 0-.3-.07.65.65 0 0 0-.33.08.53.53 0 0 0-.21.2.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.08.32-.12.52-.12.18 0 .34.03.48.11a.8.8 0 0 1 .46.75c0 .12-.02.23-.06.34-.04.1-.1.22-.2.36-.11.13-.25.29-.44.48l-.8.82.1-.18v.18l-.1-.07h1.56v.35h-1.99Zm3.66.07a.9.9 0 0 1-.59-.2 1.24 1.24 0 0 1-.37-.55 2.52 2.52 0 0 1-.13-.85c0-.34.05-.62.13-.86.09-.24.21-.43.37-.56a.9.9 0 0 1 .59-.2.9.9 0 0 1 .58.2c.16.13.28.32.37.56.09.24.13.52.13.85 0 .34-.04.62-.13.86s-.21.42-.37.56a.9.9 0 0 1-.58.2Zm0-.33c.14 0 .27-.05.37-.16.1-.1.19-.25.24-.44.06-.19.09-.41.09-.67 0-.27-.03-.5-.09-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.37-.16.52.52 0 0 0-.38.16 1 1 0 0 0-.24.44c-.05.19-.08.41-.08.67 0 .27.03.5.08.68a1 1 0 0 0 .24.44c.1.1.23.16.38.16Zm1.71.26v-.27l1.04-1.12.3-.35c.08-.1.13-.18.16-.25a.66.66 0 0 0 .05-.25.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.07.65.65 0 0 0-.33.08.53.53 0 0 0-.21.2.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.08.32-.12.52-.12.18 0 .34.03.48.11a.8.8 0 0 1 .46.75c0 .12-.01.23-.05.34-.04.1-.12.22-.22.36-.1.13-.24.29-.43.48l-.8.82.1-.18v.18l-.09-.07h1.55v.35h-1.99Zm3.97 0v-.64h-1.5v-.35l.26-.42.26-.42.27-.43a61.1 61.1 0 0 1 .53-.81h.55v2.1h.44v.33h-.44v.64h-.37Zm-1.1-.98h1.1v-1.73h-.03a18.4 18.4 0 0 0-.65 1.01 25.83 25.83 0 0 0-.43.7v.02Z"
            />
            <rect
              width={48.71}
              height={8.24}
              x={198.58}
              y={132.2}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M202.32 134.3a2.02 2.02 0 1 0 1 3.77l.24.4a2.49 2.49 0 1 1 1.24-2.16c0 .27-.08.56-.25.8a.96.96 0 0 1-.78.41.69.69 0 0 1-.66-.44c-.36.42-.94.6-1.41.32-.56-.32-.65-1.06-.32-1.62.32-.56 1-.85 1.56-.53.35.2.52.58.5.96v.04c0 .22.02.44.08.6.02.08.06.13.1.16.03.02.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.13-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.27-.55-.27-.16-.7-.04-.93.36-.24.4-.12.83.15.99.27.15.7.04.93-.37a.92.92 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={206.05} y={137.48}>
                Christine Sanchez
              </tspan>
            </text>
          </g>
        </g>
        <g clipPath="url(#applicantTracker-n)">
          <rect
            width={60.19}
            height={216}
            x={256.81}
            y={4}
            fill={templateStyles['boardBackground']}
            rx={0.93}
          />
          <rect
            width={15.7}
            height={5.92}
            x={259.45}
            y={9.13}
            fill={tagBackgroundColors['greenLight']}
            rx={0.78}
          />
          <rect
            width={15.7}
            height={5.92}
            x={259.45}
            y={9.13}
            stroke={tagBorderColors['greenLight']}
            strokeWidth={0.3}
            rx={0.78}
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={261.2} y={13.25}>
              {formatMessage(
                applicantTrackerMessages['applicant-tracker.field-2-select-option-5']
              )}
            </tspan>
          </text>
          <g filter="url(#applicantTracker-o)">
            <rect
              width={55.21}
              height={82.87}
              x={259.3}
              y={18.93}
              fill={templateStyles['background']}
              rx={1.24}
            />
            <rect
              width={31.71}
              height={8.24}
              x={261.79}
              y={22.67}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M265.52 24.77a2.02 2.02 0 1 0 1.01 3.77l.24.4a2.48 2.48 0 0 1-3.74-2.15 2.49 2.49 0 1 1 4.98 0c0 .26-.09.55-.25.78a.96.96 0 0 1-.79.42.69.69 0 0 1-.66-.44c-.36.41-.94.6-1.41.32-.55-.32-.65-1.06-.32-1.63.32-.56 1.01-.85 1.56-.53.35.2.52.58.51.97v.04c0 .21.01.43.07.6.03.08.06.13.1.15.03.03.07.05.15.05a.5.5 0 0 0 .4-.22.9.9 0 0 0 .17-.51c0-1.12-.9-2.02-2.02-2.02Zm.66 1.9c0-.25-.1-.46-.27-.55-.27-.16-.7-.05-.93.36-.23.4-.12.83.15.98.27.16.7.04.93-.36a.91.91 0 0 0 .12-.4v-.03Z"
              clipRule="evenodd"
            />
            <path
              fill={templateStyles['fontColor']}
              d="M269.64 28.29v-3.07h1.18c.2 0 .37.04.51.11.15.08.26.19.34.32.08.14.13.3.13.48 0 .22-.06.4-.17.56a.85.85 0 0 1-.45.32l.7 1.28h-.44l-.66-1.22h-.75v1.22h-.38Zm.39-1.56h.75c.2 0 .35-.05.46-.15.1-.1.16-.24.16-.43a.56.56 0 0 0-.17-.43.66.66 0 0 0-.47-.16h-.73v1.17Zm3.3 1.6c-.22 0-.41-.05-.57-.14a.97.97 0 0 1-.37-.41 1.45 1.45 0 0 1-.13-.64c0-.24.05-.46.13-.63a.96.96 0 0 1 .93-.55c.22 0 .4.04.56.14.16.1.28.23.37.4.09.18.13.4.13.64 0 .25-.04.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.14 0 .26-.03.36-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.46a.62.62 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.47c.06.12.13.22.23.29.1.07.23.1.37.1Zm2.76.33c-.1 0-.2-.02-.3-.05a.8.8 0 0 1-.24-.14.79.79 0 0 1-.17-.22h-.04v.37h-.37v-3.2h.37v1.27h.04a.7.7 0 0 1 .42-.35c.09-.04.19-.05.3-.05.19 0 .36.04.5.14s.26.24.33.42c.08.17.12.38.12.62s-.04.45-.12.63a.95.95 0 0 1-.33.41.88.88 0 0 1-.5.15Zm-.08-.33c.14 0 .26-.03.36-.1.1-.07.17-.17.23-.3.05-.13.08-.28.08-.46s-.03-.33-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.36-.1.62.62 0 0 0-.36.1.66.66 0 0 0-.23.3c-.06.13-.08.28-.08.46s.02.33.08.46c.05.13.13.23.23.3.1.07.22.1.36.1Zm1.63.29v-2.3h.37v2.3h-.37Zm.18-2.74a.25.25 0 0 1-.25-.25c0-.07.02-.13.07-.18a.25.25 0 0 1 .18-.08c.07 0 .13.03.19.08.05.05.07.1.07.18a.25.25 0 0 1-.25.26Zm2.16 2.74v-3.07h.38v2.72h1.48v.35h-1.86Zm3.26.04c-.22 0-.4-.05-.56-.14a.96.96 0 0 1-.37-.41 1.43 1.43 0 0 1-.13-.64c0-.24.05-.46.13-.63.09-.18.21-.32.37-.41.16-.1.34-.14.56-.14.22 0 .4.04.56.14.16.1.28.23.37.4.08.18.13.4.13.64 0 .25-.05.46-.13.64a.95.95 0 0 1-.93.55Zm0-.33c.15 0 .27-.03.37-.1.1-.07.18-.17.23-.3.05-.12.08-.28.08-.46s-.03-.34-.08-.46a.63.63 0 0 0-.23-.3.64.64 0 0 0-.37-.1.64.64 0 0 0-.37.1.63.63 0 0 0-.23.3c-.05.12-.08.28-.08.46s.03.34.08.47c.06.12.13.22.23.29.1.07.23.1.37.1Zm1.63 1.05V26h.37v.36h.04a.76.76 0 0 1 .42-.36c.09-.03.18-.04.3-.04.19 0 .35.05.5.14.14.1.25.24.33.42.08.17.12.38.12.62s-.04.45-.12.63a.95.95 0 0 1-.33.41.88.88 0 0 1-.5.15.86.86 0 0 1-.54-.19.7.7 0 0 1-.18-.21h-.04v1.12h-.37Zm1.04-1.05c.14 0 .26-.03.35-.1.1-.07.18-.17.23-.3.06-.13.08-.28.08-.46s-.02-.33-.08-.46a.64.64 0 0 0-.23-.3.61.61 0 0 0-.35-.1.62.62 0 0 0-.36.1.67.67 0 0 0-.24.3c-.05.13-.08.28-.08.46s.03.33.08.46c.06.13.14.23.24.3.1.07.22.1.36.1Zm2.56.33c-.22 0-.41-.05-.57-.15a.96.96 0 0 1-.36-.4 1.46 1.46 0 0 1-.12-.63c0-.24.04-.45.12-.62a.97.97 0 0 1 .9-.57c.21 0 .39.04.54.14.15.1.26.23.34.4.08.18.13.38.13.6v.15h-1.84v-.3h1.64l-.18.27v-.14c0-.18-.02-.33-.08-.45a.57.57 0 0 0-.55-.34.61.61 0 0 0-.33.09.62.62 0 0 0-.23.26 1 1 0 0 0-.09.44v.14c0 .17.03.3.09.42a.62.62 0 0 0 .6.36c.1 0 .19-.01.26-.04a.59.59 0 0 0 .2-.11.38.38 0 0 0 .1-.14v-.01h.38v.01a.71.71 0 0 1-.11.23.84.84 0 0 1-.2.2 1 1 0 0 1-.28.14c-.1.03-.23.05-.36.05Zm1.5-.04v-.27l1.32-1.68v-.04h-1.32V26h1.75v.27l-1.31 1.68v.03h1.32v.3h-1.76Z"
            />
            <rect
              width={39.7}
              height={5.92}
              x={261.94}
              y={33.55}
              fill={tagBackgroundColors['green']}
              rx={0.78}
            />
            <rect
              width={39.7}
              height={5.92}
              x={261.94}
              y={33.55}
              stroke={tagBorderColors['green']}
              strokeWidth={0.3}
              rx={0.78}
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={263} y={37.67}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.field-3-select-option-2']
                )}
              </tspan>
            </text>
            <rect
              width={27.49}
              height={8.24}
              x={261.79}
              y={42.11}
              fill={templateStyles['userBackground']}
              rx={0.93}
            />
            <path
              fill={templateStyles['fontColor']}
              d="M264.08 47.8c-.13 0-.25-.01-.36-.05a.75.75 0 0 1-.43-.4.92.92 0 0 1-.07-.31V47h.38v.02c0 .07.03.14.07.21.03.06.09.12.15.16.07.03.16.05.26.05.17 0 .3-.05.39-.14.09-.1.13-.25.13-.43v-2.22h.38v2.22c0 .2-.03.36-.1.5a.74.74 0 0 1-.31.32 1 1 0 0 1-.49.1Zm2.27-.03a.9.9 0 0 1-.4-.08.67.67 0 0 1-.27-.24.65.65 0 0 1-.1-.36c0-.14.04-.25.1-.35.07-.1.16-.17.29-.23.12-.05.27-.09.45-.1l.84-.05v.3l-.8.05a.7.7 0 0 0-.38.1.31.31 0 0 0-.12.27c0 .12.05.21.13.28.1.06.2.1.34.1.12 0 .23-.03.33-.08s.18-.12.23-.2a.52.52 0 0 0 .09-.3v-.72c0-.14-.05-.25-.13-.32-.09-.07-.22-.11-.39-.11a.69.69 0 0 0-.34.07.36.36 0 0 0-.17.2v.02h-.38V46a.61.61 0 0 1 .16-.31.8.8 0 0 1 .3-.21c.14-.05.28-.08.44-.08.2 0 .35.03.48.1.13.05.23.14.3.26.06.1.1.25.1.4v1.57h-.37v-.33h-.04a.78.78 0 0 1-.4.33.92.92 0 0 1-.3.04Zm1.77-.04v-2.29h.37v.35h.04a.64.64 0 0 1 .25-.29c.1-.07.25-.1.41-.1.26 0 .46.07.6.22.14.15.2.36.2.63v1.48h-.36v-1.4c0-.2-.05-.35-.14-.45-.08-.1-.22-.15-.4-.15a.62.62 0 0 0-.32.08.54.54 0 0 0-.2.22.77.77 0 0 0-.08.35v1.35h-.37Zm3.77 0v-.26l1.04-1.12.3-.35c.08-.1.13-.18.16-.26a.66.66 0 0 0 .04-.24c0-.12-.02-.21-.07-.3a.52.52 0 0 0-.2-.2.62.62 0 0 0-.3-.07.65.65 0 0 0-.33.07.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.82c.15-.08.32-.12.52-.12.18 0 .34.04.48.11.14.08.26.18.34.3a.8.8 0 0 1 .12.45c0 .12-.02.23-.06.34-.04.1-.1.23-.21.36-.1.13-.25.3-.43.48l-.8.82.1-.17v.17l-.1-.06h1.56v.34h-2Zm2.47.78.19-1.2h.42l-.33 1.2h-.28Zm2.61-.78v-.26l1.04-1.12.3-.35c.08-.1.13-.18.16-.26a.66.66 0 0 0 .05-.24.6.6 0 0 0-.07-.3.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.07.65.65 0 0 0-.33.07.53.53 0 0 0-.21.21.62.62 0 0 0-.08.32h-.37a.9.9 0 0 1 .49-.81c.15-.09.32-.13.52-.13.18 0 .34.04.48.11a.8.8 0 0 1 .46.75c0 .12-.01.23-.05.34-.04.1-.12.23-.22.36-.1.13-.24.3-.43.48l-.8.82.1-.17v.17l-.09-.06h1.55v.34h-1.99Zm3.66.08a.9.9 0 0 1-.58-.2 1.23 1.23 0 0 1-.38-.55 2.52 2.52 0 0 1-.13-.86c0-.33.05-.62.13-.86.1-.24.21-.42.38-.55a.9.9 0 0 1 .58-.2.9.9 0 0 1 .58.2c.16.13.29.31.37.55.1.24.13.53.13.86 0 .33-.04.61-.13.85-.08.24-.2.43-.37.56a.9.9 0 0 1-.58.2Zm0-.34c.14 0 .27-.05.37-.15a1 1 0 0 0 .24-.44c.06-.2.09-.42.09-.68 0-.27-.03-.49-.09-.68a.98.98 0 0 0-.24-.44.51.51 0 0 0-.37-.15.52.52 0 0 0-.38.15 1 1 0 0 0-.24.44c-.05.19-.08.41-.08.68 0 .26.03.49.08.68.06.19.14.33.24.44.1.1.23.15.38.15Zm1.71.26v-.26l1.04-1.12.3-.35c.08-.1.13-.18.16-.26a.66.66 0 0 0 .05-.24c0-.12-.02-.21-.07-.3a.52.52 0 0 0-.2-.2.62.62 0 0 0-.31-.07.65.65 0 0 0-.32.07.54.54 0 0 0-.22.21.62.62 0 0 0-.07.32h-.37a.9.9 0 0 1 .48-.82c.15-.08.33-.12.52-.12.18 0 .34.04.49.11.14.08.25.18.33.3a.8.8 0 0 1 .13.45c0 .12-.02.23-.06.34-.04.1-.11.23-.22.36-.1.13-.24.3-.43.48l-.79.82.1-.17v.17l-.1-.06h1.55v.34h-1.99Zm3.64.08c-.19 0-.36-.04-.5-.12a.92.92 0 0 1-.52-.75v-.02h.36v.02a.57.57 0 0 0 .34.46c.1.04.2.07.32.07a.7.7 0 0 0 .36-.1c.1-.05.19-.14.25-.24.06-.1.08-.23.08-.37a.72.72 0 0 0-.09-.36.63.63 0 0 0-.24-.25.69.69 0 0 0-.35-.1c-.1 0-.2.02-.28.05a.66.66 0 0 0-.37.33h-.33l.16-1.77h1.7v.35h-1.4l-.1 1.03h.03c.05-.06.1-.12.17-.17a.9.9 0 0 1 .49-.14.94.94 0 0 1 .86.5c.09.15.13.32.13.52 0 .21-.05.4-.14.55a.98.98 0 0 1-.38.37c-.16.1-.34.14-.55.14Z"
            />
            <rect
              width={28.71}
              height={8.24}
              x={261.79}
              y={52.84}
              fill={templateStyles['userBackground']}
              rx={4.12}
            />
            <path
              fill={templateStyles['icon']}
              fillRule="evenodd"
              d="M265.52 54.94a2.02 2.02 0 1 0 1.01 3.78l.24.4a2.48 2.48 0 0 1-3.74-2.15 2.49 2.49 0 1 1 4.98 0c0 .26-.09.55-.25.78a.96.96 0 0 1-.79.42.69.69 0 0 1-.66-.44c-.36.41-.94.59-1.41.31-.55-.31-.65-1.06-.32-1.62.32-.56 1.01-.85 1.56-.53.35.2.52.58.51.97v.04c0 .2.01.43.07.6.03.07.06.12.1.15.03.03.07.05.15.05a.5.5 0 0 0 .4-.23.9.9 0 0 0 .17-.5c0-1.12-.9-2.03-2.02-2.03Zm.66 1.9c0-.25-.1-.45-.27-.55-.27-.15-.7-.04-.93.37-.23.4-.12.83.15.98.27.15.7.04.93-.36a.91.91 0 0 0 .12-.4v-.04Z"
              clipRule="evenodd"
            />
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={269.25} y={58.13}>
                Brian Lin
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={261.79} y={68.24}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-7-cell-5']
                )}
              </tspan>
            </text>
            <text
              xmlSpace="preserve"
              fill={templateStyles['fontColor']}
              fontFamily={templateStyles['fontFamily']}
              fontSize={4.36}
              letterSpacing="0em"
              style={{
                whiteSpace: 'pre'
              }}
            >
              <tspan x={261.79} y={77.73}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-7-cell-6']
                ).substring(0, 19)}
              </tspan>
              <tspan x={261.79} y={83.95}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-7-cell-6']
                ).substring(19, 36)}
              </tspan>
              <tspan x={261.79} y={90.17}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-7-cell-6']
                ).substring(36, 58)}
              </tspan>
              <tspan x={260.79} y={96.39}>
                {formatMessage(
                  applicantTrackerMessages['applicant-tracker.entry-7-cell-6']
                ).substring(58)}
              </tspan>
            </text>
          </g>
          <path
            fill={templateStyles['icon']}
            fillRule="evenodd"
            d="M275.42 111.07V113h.46v-1.94h1.95v-.47h-1.94v-1.94h-.47v1.94h-1.95v.47h1.95Z"
            clipRule="evenodd"
          />
          <text
            xmlSpace="preserve"
            fill={templateStyles['fontColor']}
            fontFamily={templateStyles['fontFamily']}
            fontSize={4.36}
            fontWeight={510}
            letterSpacing="0em"
            style={{
              whiteSpace: 'pre'
            }}
          >
            <tspan x={279.65} y={111.99}>
              {formatMessage(messages['templates-preview.add-entry'])}
            </tspan>
          </text>
        </g>
        <path
          fill={templateStyles['boardBackground']}
          d="M320 4.93c0-.51.42-.93.93-.93h10.58c.52 0 .93.42.93.93V15.2c0 .52-.41.93-.93.93h-10.58a.93.93 0 0 1-.93-.93V4.93Z"
        />
        <path
          fill={templateStyles['background']}
          fillOpacity={0.01}
          d="M322.49 6.33h7.47v7.47h-7.47z"
        />
        <path
          fill={templateStyles['icon']}
          d="M326.22 7.58c.16 0 .3.12.31.27v1.91h1.87a.31.31 0 0 1 .04.62h-1.91v1.86a.31.31 0 0 1-.62.04v-1.9h-1.87a.31.31 0 0 1-.03-.62h1.89V7.89c0-.17.14-.31.31-.31Z"
        />
      </g>
      <defs>
        <filter
          id="applicantTracker-c"
          width={55.97}
          height={72}
          x={6.11}
          y={18.56}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <filter
          id="applicantTracker-e"
          width={55.97}
          height={78}
          x={69.31}
          y={18.56}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <filter
          id="applicantTracker-f"
          width={55.97}
          height={128.49}
          x={69.31}
          y={97.91}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <filter
          id="applicantTracker-i"
          width={55.97}
          height={84}
          x={132.52}
          y={18.56}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <filter
          id="applicantTracker-k"
          width={55.97}
          height={78}
          x={195.72}
          y={18.56}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <filter
          id="applicantTracker-l"
          width={55.97}
          height={119.48}
          x={195.72}
          y={97.91}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <filter
          id="applicantTracker-o"
          width={55.97}
          height={84}
          x={258.92}
          y={18.56}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={0.38} />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1228_17847" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.19} />
          <feColorMatrix values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0" />
          <feBlend
            in2="effect1_dropShadow_1228_17847"
            result="effect2_dropShadow_1228_17847"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1228_17847"
            result="shape"
          />
        </filter>
        <clipPath id="applicantTracker-a">
          <rect width={336} height={142} fill={templateStyles['background']} rx={3} />
        </clipPath>
        <clipPath id="applicantTracker-b">
          <rect
            width={60.19}
            height={216}
            x={4}
            y={4}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="applicantTracker-d">
          <rect
            width={60.19}
            height={216}
            x={67.2}
            y={4}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="applicantTracker-h">
          <rect
            width={60.19}
            height={216}
            x={130.4}
            y={4}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="applicantTracker-j">
          <rect
            width={60.19}
            height={216}
            x={193.61}
            y={4}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
        <clipPath id="applicantTracker-n">
          <rect
            width={60.19}
            height={216}
            x={256.81}
            y={4}
            fill={templateStyles['background']}
            rx={0.93}
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ApplicantTracker;
